import { useQuery } from '@tanstack/react-query';

import { GetTwoFactorSetupResponse } from '../../../../../types/requests';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../../logic/unwrapNonPaginatedResponseDataAs';
import { NonPaginatedResponse } from '../../../../types/NonPaginatedResponse';
import { getTwoFactorSetup } from '../../requests/getTwoFactorSetup';

export const useGetTwoFactorSetup = (
  method: string,
  options?: { enabled?: boolean },
) => {
  const { constructGet } = useRequestConstructor();
  const { data, ...rest } = useQuery<
    NonPaginatedResponse<GetTwoFactorSetupResponse> | undefined
  >({
    queryKey: ['authentication', 'two-factor-setup', method],
    queryFn: () => getTwoFactorSetup(constructGet, method),
    enabled: !!method,
    ...options,
  });
  return {
    ...unwrapNonPaginatedResponseDataAs(data, 'twoFactorSetup'),
    ...rest,
  };
};
